export enum EsgotamentoSanitarioTipo {
  FOSSA = 'FOSSA',
  CEU_ABERTO = 'CEU_ABERTO',
  OUTRO = 'OUTRO',
}
